import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, NavLink } from "react-router-dom";
import { matchPath } from "react-router";

import { Layout, Menu, Breadcrumb, Button, Icon, Row, Col, Alert } from 'antd';
import { Users, UserDetail } from './User';
import { UserModel, UserListStore } from './UsersStore';
import { ShippingItems } from './ShippingItem';
import { ShippingItemDetail } from './ShippingItemDetail';
import { PrintShippingItems} from './PrintShippingItems';
import { ExportData } from './ExportData';
import { UploadData } from './Upload';
import { ShippingItemModel, ShippingItemListStore } from './ShippingItemsStore';
import CustomFooter from './CustomFooter';

import { normalizeMatchPath } from './common';

import { AuthStoreContext, UserStoreContext, ShippingItemStoreContext } from './AppContexts';

const { Header, Content, Sider } = Layout;

const SubMenu = Menu.SubMenu;

const THEME = 'light';
 
class Dashboard extends React.Component {
	static contextType = AuthStoreContext;

	state = {
		collapsed: true,
	};
	userListStore = new UserListStore({ model: UserModel, auth: this.context });
	shippingItemListStore = new ShippingItemListStore({ model: ShippingItemModel, auth: this.context });

	menu = [
		{ key: "1", to: "/", iconType: "global", text: "Bolle e colli", isDefault: true }
		,{ key: "2", to: "/users", iconType: "user", text: "Utenti" }
		,{ key: "3", to: "/upload", iconType: "upload", text: "Upload" }
	];

	onCollapse = (collapsed) => {
		console.log(collapsed);
		this.setState({ collapsed });
	}

	toggleSidebar = () => {
		this.setState( (prevState, props) => ({
			collapsed: !prevState.collapsed
		}));
	}

	logout = () => {
		this.context.logout().then( () => {
			this.props.history.push('/');
		});
	}

	getBreadcrumb() {
		return (
			<Breadcrumb style={{ margin: '16px 0' }}>

				<Breadcrumb.Item>
					<NavLink to={`${normalizeMatchPath(this)}/`}></NavLink>
				</Breadcrumb.Item>

			{ matchPath(this.props.location.pathname, { path: '/users' }) ? 
				<Breadcrumb.Item>
					<NavLink to={`${normalizeMatchPath(this)}/users`}>Utenti</NavLink>
				</Breadcrumb.Item> :  null }

			{ matchPath(this.props.location.pathname, { path: '/users/view/:id' }) ? 
				<Breadcrumb.Item>Dettaglio utente</Breadcrumb.Item> :  null }

			{ matchPath(this.props.location.pathname, { path: '/users/new' }) ? 
				<Breadcrumb.Item>Crea utente</Breadcrumb.Item> :  null }

			{ matchPath(this.props.location.pathname, { path: '/', exact: true }) ? 
				<Breadcrumb.Item>
					<NavLink to={`${normalizeMatchPath(this)}/`}>Bolle e colli</NavLink>
				</Breadcrumb.Item> :  null }

			{ matchPath(this.props.location.pathname, { path: '/shipping-items/view/:id' }) ? 
				[<Breadcrumb.Item key="1">
					<NavLink to={`${normalizeMatchPath(this)}/`}>Bolle e colli</NavLink>
				</Breadcrumb.Item>
				,<Breadcrumb.Item key="2">Dettaglio collo</Breadcrumb.Item>] :  null }

			{ matchPath(this.props.location.pathname, { path: '/shipping-items/new' }) ? 
				[<Breadcrumb.Item key="1">
					<NavLink to={`${normalizeMatchPath(this)}/`}>Bolle e colli</NavLink>
				</Breadcrumb.Item>
				,<Breadcrumb.Item key="2">Crea collo</Breadcrumb.Item>] :  null }

			{ matchPath(this.props.location.pathname, { path: '/shipping-items/printA4' }) ? 
				[<Breadcrumb.Item key="1">
					<NavLink to={`${normalizeMatchPath(this)}/`}>Bolle e colli</NavLink>
				</Breadcrumb.Item>
				,<Breadcrumb.Item key="2">Stampa</Breadcrumb.Item>] :  null }

			{ matchPath(this.props.location.pathname, { path: '/shipping-items/export-spreadsheets' }) ? 
				[<Breadcrumb.Item key="1">
					<NavLink to={`${normalizeMatchPath(this)}/`}>Bolle e colli</NavLink>
				</Breadcrumb.Item>
				,<Breadcrumb.Item key="2">Esporta dati...</Breadcrumb.Item>] :  null }

			{ matchPath(this.props.location.pathname, { path: '/upload' }) ? 
				<Breadcrumb.Item>
					<NavLink to={`${normalizeMatchPath(this)}/upload`}>Carica</NavLink>
				</Breadcrumb.Item> :  null }

			</Breadcrumb>
		);
	}

	getMenuSelectedKeys() {
		let selectedKeys = [], defaultKey = null;
		this.menu.forEach( (entry) => {
			if (entry.isDefault){
				defaultKey = entry.key;
				return;
			}
			if (matchPath(this.props.location.pathname, { path: entry.to, exact: false })){
				selectedKeys.push(entry.key);
			}
		});
		if (selectedKeys.length == 0){
			selectedKeys.push(defaultKey);
		}
		return selectedKeys;
	}

	render() {
		return (
		<Layout style={{ minHeight: '100vh' }}>
			<Sider theme={THEME}
			collapsible
			collapsed={this.state.collapsed}
			onCollapse={this.onCollapse}>
				<div className="logo" />
				<Menu theme={THEME} selectedKeys={this.getMenuSelectedKeys()} mode="inline">
				{ this.menu.map( (entry) => (
					<Menu.Item key={entry.key}>
						<NavLink to={entry.to} className="nav-text"><Icon type={entry.iconType} /> <span>{entry.text}</span></NavLink>
					</Menu.Item>
				) )
				}
				</Menu>
			</Sider>
			<Layout>
				<Header style={{ background: '#fff', padding: 0 }}>
					<Row>
						<Col span={12}>
						{/*	<Icon className="sidebar-trigger" type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'} onClick={this.toggleSidebar} /> */}
						</Col>
						<Col span={12}>
							<div className="login-info">
								<span>Logged in as:</span> <strong className="username">{this.context.email}</strong>  &nbsp;|&nbsp; <a className="logout" onClick={this.logout}>Logout</a>
							</div>
						</Col>
					</Row>
				</Header>
				<Content style={{ margin: '0 16px' }}>
					{this.getBreadcrumb()}
					<div className="main">
						<UserStoreContext.Provider value={this.userListStore}>
							<ShippingItemStoreContext.Provider value={this.shippingItemListStore}>
								<Switch>
									<Route path={`${normalizeMatchPath(this)}/users/view/:id`} component={UserDetail} />
									<Route path={`${normalizeMatchPath(this)}/users/new`} component={UserDetail} />
									<Route exact path={`${normalizeMatchPath(this)}/users`} component={Users} />
									<Route path={`${normalizeMatchPath(this)}/shipping-items/view/:id`} component={ShippingItemDetail} />
									<Route path={`${normalizeMatchPath(this)}/shipping-items/new`} component={ShippingItemDetail} />
									<Route path={`${normalizeMatchPath(this)}/shipping-items/printA4`} component={PrintShippingItems} />
									<Route path={`${normalizeMatchPath(this)}/shipping-items/export-spreadsheets`} component={ExportData} />
									<Route path={`${normalizeMatchPath(this)}/upload`} component={UploadData} />
									<Route exact path={this.props.match.path} component={ShippingItems} />
									<Route component={component404} />;
								</Switch>
							</ShippingItemStoreContext.Provider>
						</UserStoreContext.Provider>
					</div>
				</Content>
				<CustomFooter />
			</Layout>
		</Layout>
		);
	}
}

function component404(props) {
	return <Alert message="Not found" description="This page does not exist" type="error" showIcon />
}

export default Dashboard;
